module.exports = __webpack_public_path__ + "static/media/gear.276a85ca.svg";